import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function ToggleViewButton({ areSortedByGroups, setAreSortedByGroup }: Props) {
  return (
    <div
      className={classNames(styles.toggleViewButton, {
        [styles.active]: areSortedByGroups,
      })}
      onClick={setAreSortedByGroup}
    >
      <div className={styles.toggle} />
    </div>
  );
}

export { ToggleViewButton };
